export enum OptionOrderTypeEnum {
	ORDERS = 'orders',
	POST_TRADING = 'postTrading',
}
